import { useState } from 'react';

export const useResolutionsListFilterDatePickers = () => {
  const [createdAtFromPickerOpen, setCreatedAtFromPickerOpen] =
    useState<boolean>(false);
  const [createdAtToPickerOpen, setCreatedAtToPickerOpen] =
    useState<boolean>(false);
  const [completedOnFromPickerOpen, setCompletedOnFromPickerOpen] =
    useState<boolean>(false);
  const [completedOnToPickerOpen, setCompletedOnToPickerOpen] =
    useState<boolean>(false);

  return {
    createdAtFromPickerOpen,
    createdAtToPickerOpen,
    completedOnFromPickerOpen,
    completedOnToPickerOpen,
    onCreatedAtFromPickerStatusChange: setCreatedAtFromPickerOpen,
    onCreatedAtToPickerStatusChange: setCreatedAtToPickerOpen,
    onCompletedOnFromPickerStatusChange: setCompletedOnFromPickerOpen,
    onCompletedOnToPickerStatusChange: setCompletedOnToPickerOpen
  };
};
